import apiClient from '@/api/client';
import type { Owner } from '@/types/company';

export const createOwner = async (
  companyId: string,
  data: Omit<Owner, 'id' | 'companyId'>,
): Promise<Owner> => {
  const response = await apiClient.post<Owner>(`/companies/${companyId}/owners`, data);
  return response.data;
};

export const updateOwner = async (
  companyId: string,
  ownerId: string,
  data: Partial<Omit<Owner, 'id' | 'companyId'>>,
): Promise<Owner> => {
  const response = await apiClient.put<Owner>(
    `/companies/${companyId}/owners/${ownerId}`,
    data,
  );
  return response.data;
};

export const deleteOwner = async (companyId: string, ownerId: string): Promise<void> => {
  await apiClient.delete(`/companies/${companyId}/owners/${ownerId}`);
};
